enum SensorTypeCode {
  THS = 14,
  WLS = 15,
}

export default SensorTypeCode
